import React, { useState } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import FormLabel from "@material-ui/core/FormLabel";

// @material-ui/icons
import Contacts from "@material-ui/icons/Contacts";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";

import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";

import { Controller, useFieldArray, useForm, useWatch } from "react-hook-form";
import { useHistory, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import ImageUpload from "../../components/CustomUpload/ImageUpload";
import { stakingService } from "../../services/stakingService";
import Select from "components/Select/Select";
import { Add, Remove } from "@material-ui/icons";
import { totalDaysToSeconds } from "helper/fommaters";
import { totalDaysFromSeconds } from "helper/fommaters";
import { chainOptions } from "const";

const useStyles = makeStyles(styles);

const defaultClaimFee = process.env.REACT_APP_SOFT_DEFAULT_CLAIM_FEE;

export default function StakingCreateSoft() {
  const { id } = useParams();

  const {
    register: staking,
    handleSubmit,
    control,
  } = useForm({
    shouldUnregister: true,
    defaultValues: async () => await getFormDefaultValues(id),
  });

  const history = useHistory();

  const [loading, setLoading] = useState(false);

  const {
    fields: rewardRateFields,
    append,
    remove,
  } = useFieldArray({
    control,
    name: "softConfig.rewardRates", // unique name for your Field Array
  });

  const {
    fields: specialFeeFields,
    append: appendFee,
    remove: removeFee,
  } = useFieldArray({
    control,
    name: "softConfig.specialFees",
  });

  const rewardRates = useWatch({
    control,
    name: "softConfig.rewardRates",
  });

  const status = useWatch({
    control,
    name: "status",
  });

  async function create(payload) {
    try {
      if (loading) return;
      setLoading(true);
      await stakingService.createSoft(payload);
      toast.success("Created");
      window.setTimeout(() => history.push("/admin/staking/"), 500);
    } catch (e) {
      toast.error(e?.response?.data?.message[0] || e?.message[0] || "Cannot create");
      console.log(e);
    } finally {
      setLoading(false);
    }
  }

  async function update(payload) {
    try {
      if (loading) return;
      setLoading(true);
      await stakingService.update(id, payload);
      toast.success("Updated");
      window.setTimeout(() => history.push("/admin/staking/"), 500);
    } catch (e) {
      toast.error(e?.response?.data?.message[0] || "Cannot update");
      console.log(e);
    } finally {
      setLoading(false);
    }
  }

  async function onSubmit(formData) {
    if (!formData.rewardCoin || !formData.name) {
      alert("please add data");
      return;
    }

    if (rewardRates?.length === 0) {
      toast.error("Please add reward rates");
      return;
    }

    const basicRates = rewardRates?.filter((item) => item.type === "basic");
    if (basicRates?.length > 1) {
      toast.error("Please add only one basic rate");
      return;
    }

    const payload = {
      ...formData,
    };

    payload.softConfig.lockTime = totalDaysToSeconds(payload.softConfig.lockTime);

    if (id) {
      update(payload);
    } else {
      create(payload);
    }
  }

  async function getFormDefaultValues(id) {
    if (!id)
      return {
        softConfig: {
          claimFee: +defaultClaimFee,
        },
      };
    const { data } = await stakingService.view(id);

    data.softConfig.lockTime = totalDaysFromSeconds(data.softConfig.lockTime);
    return data;
  }

  const classes = useStyles();
  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <Contacts />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>
              {!id ? "Create Soft Staking" : "Edit Soft Staking"}
            </h4>
          </CardHeader>
          <CardBody>
            <form onSubmit={handleSubmit(onSubmit)}>
              <GridContainer>
                <GridItem xs={12} sm={12} md={8}>
                  <h4> Detail </h4>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={3}>
                      <FormLabel className={classes.labelHorizontal}>Name</FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={7}>
                      <CustomInput
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "text",
                          placeholder: "Name",
                          required: true,
                          ...staking("name"),
                        }}
                      />
                    </GridItem>
                  </GridContainer>

                  <GridContainer>
                    <GridItem xs={12} sm={12} md={3}>
                      <FormLabel className={classes.labelHorizontal}>Address</FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={7}>
                      <CustomInput
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          disabled: true,
                          type: "text",
                          ...staking("address"),
                        }}
                      />
                    </GridItem>
                  </GridContainer>

                  <GridContainer>
                    <GridItem xs={12} sm={12} md={3}>
                      <FormLabel className={classes.labelHorizontal}>Nft collections</FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={4}>
                      <CustomInput
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          placeholder: "0xbaj24...",
                          required: true,
                          type: "text",
                          disabled: !["not_deployed", undefined].includes(status),
                          ...staking("collections[0].address"),
                        }}
                      />
                    </GridItem>

                    <GridItem xs={12} sm={12} md={3}>
                      <CustomInput
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          placeholder: "Name",
                          required: true,
                          type: "text",
                          ...staking("collections[0].name"),
                        }}
                      />
                    </GridItem>
                    <GridItem md={3} />

                    <GridItem xs={12} sm={12} md={5}>
                      <CustomInput
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          placeholder: "Buy link",
                          type: "text",
                          ...staking("collections[0].link"),
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={2}>
                      <CustomInput
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          name: "collectionPrice",
                          placeholder: "NFT Price: 150",
                          type: "text",
                          ...staking("collections[0].price"),
                        }}
                      />
                    </GridItem>
                  </GridContainer>

                  <br />

                  <GridContainer>
                    <GridItem xs={12} sm={12} md={3}>
                      <FormLabel className={classes.labelHorizontal}>Reward coin</FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={5}>
                      <CustomInput
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          required: true,
                          type: "text",
                          placeholder: "0xbaj24...",
                          disabled: !["not_deployed", undefined].includes(status),
                          ...staking("rewardCoin", {
                            required: true,
                          }),
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={2}>
                      <CustomInput
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          required: true,
                          placeholder: "CORGI",
                          type: "text",
                          ...staking("rewardCoinName"),
                        }}
                      />
                    </GridItem>
                  </GridContainer>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={3}>
                      <FormLabel className={classes.labelHorizontal}>Chain</FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={7}>
                      <Controller
                        control={control}
                        name="chainId"
                        render={({ field: { value, onChange } }) => (
                          <Select
                            name="chainId"
                            label=" "
                            onChange={onChange}
                            value={value ?? "25"}
                            options={chainOptions()}
                          />
                        )}
                      />
                    </GridItem>
                  </GridContainer>

                  <GridContainer>
                    <GridItem xs={12} sm={12} md={3}>
                      <FormLabel className={classes.labelHorizontal}>External link</FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={7}>
                      <CustomInput
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "text",
                          ...staking("externalLink"),
                        }}
                      />
                    </GridItem>
                  </GridContainer>

                  <GridContainer>
                    <GridItem xs={12} sm={12} md={3}>
                      <FormLabel className={classes.labelHorizontal}>Description</FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={7}>
                      <CustomInput
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "text",
                          multiline: true,
                          rows: 4,
                          ...staking("description"),
                        }}
                      />
                    </GridItem>
                  </GridContainer>

                  <h4> Soft staking config </h4>

                  <GridContainer>
                    <GridItem xs={12} sm={12} md={3}>
                      <FormLabel className={classes.labelHorizontal}>Lock time</FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={5}>
                      <CustomInput
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "number",
                          required: true,
                          ...staking("softConfig.lockTime", {
                            required: true,
                            valueAsNumber: true,
                          }),
                        }}
                      />
                    </GridItem>

                    <GridItem xs={12} sm={12} md={2}>
                      <Select
                        value="day"
                        name="Type"
                        label=" "
                        options={[{ value: "day", label: "Day" }]}
                      />
                    </GridItem>
                  </GridContainer>

                  <GridContainer>
                    <GridItem xs={12} sm={12} md={3}>
                      <FormLabel className={classes.labelHorizontal}>Max NFT per batch</FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={2}>
                      <CustomInput
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          required: true,
                          type: "number",
                          ...staking("softConfig.maxNftPerBatch", {
                            required: true,
                            valueAsNumber: true,
                          }),
                        }}
                      />
                    </GridItem>

                    <GridItem xs={12} sm={12} md={3}>
                      <FormLabel className={classes.labelHorizontal}>Max batch per user</FormLabel>
                    </GridItem>

                    <GridItem xs={12} sm={12} md={2}>
                      <CustomInput
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          required: true,
                          type: "number",
                          ...staking("softConfig.maxBatchPerUser", {
                            required: true,
                            valueAsNumber: true,
                          }),
                        }}
                      />
                    </GridItem>
                  </GridContainer>

                  <GridContainer alignItems="center">
                    <GridItem xs={12} sm={12} md={3}>
                      <FormLabel className={classes.labelHorizontal}>Reward rate</FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={3}>
                      <Button
                        justIcon={true}
                        color="success"
                        size="sm"
                        onClick={() => {
                          append({
                            type: "rank",
                            rewardPerNft: 0,
                          });
                        }}
                      >
                        <Add />
                      </Button>
                    </GridItem>
                  </GridContainer>
                  {rewardRateFields.map((field, index) => (
                    <GridContainer key={field.id} alignItems="center">
                      <GridItem xs={12} sm={12} md={3}>
                        <FormLabel className={classes.labelHorizontal}>Rate {index + 1}</FormLabel>
                      </GridItem>

                      <GridItem xs={12} sm={12} md={2}>
                        <Controller
                          control={control}
                          name={`softConfig.rewardRates[${index}].type`}
                          render={({ field: { value, onChange } }) => (
                            <Select
                              label=" "
                              onChange={onChange}
                              value={value || "basic"}
                              options={[
                                { value: "basic", label: "Basic" },
                                { value: "rank", label: "Rank" },
                                { value: "trait", label: "Trait" },
                              ]}
                            />
                          )}
                        />
                      </GridItem>

                      <GridItem xs={12} sm={12} md={2}>
                        <CustomInput
                          labelText="Reward per NFT"
                          formControlProps={{
                            fullWidth: true,
                          }}
                          inputProps={{
                            required: true,
                            placeholder: "200",
                            step: ".0001",
                            type: "number",
                            ...staking(`softConfig.rewardRates[${index}].rewardPerNft`, {
                              valueAsNumber: true,
                            }),
                          }}
                        />
                      </GridItem>

                      {rewardRates?.[index]?.type === "rank" && (
                        <>
                          <GridItem xs={12} sm={12} md={2}>
                            <CustomInput
                              labelText="from"
                              formControlProps={{
                                fullWidth: true,
                              }}
                              inputProps={{
                                placeholder: "1",
                                required: true,
                                type: "number",
                                ...staking(`softConfig.rewardRates[${index}].rank.from`, {
                                  valueAsNumber: true,
                                }),
                              }}
                            />
                          </GridItem>
                          <GridItem xs={12} sm={12} md={2}>
                            <CustomInput
                              labelText="to"
                              formControlProps={{
                                fullWidth: true,
                              }}
                              inputProps={{
                                placeholder: "1",
                                required: true,
                                type: "number",
                                ...staking(`softConfig.rewardRates[${index}].rank.to`, {
                                  valueAsNumber: true,
                                }),
                              }}
                            />
                          </GridItem>
                        </>
                      )}

                      {rewardRates?.[index]?.type === "trait" && (
                        <>
                          <GridItem xs={12} sm={12} md={2}>
                            <CustomInput
                              labelText="Trait type"
                              formControlProps={{
                                fullWidth: true,
                              }}
                              inputProps={{
                                placeholder: "background",
                                required: true,
                                ...staking(`softConfig.rewardRates[${index}].trait.traitType`, {
                                  required: true,
                                }),
                              }}
                            />
                          </GridItem>
                          <GridItem xs={12} sm={12} md={2}>
                            <CustomInput
                              labelText="Trait value"
                              formControlProps={{
                                fullWidth: true,
                              }}
                              inputProps={{
                                placeholder: "red",
                                required: true,
                                ...staking(`softConfig.rewardRates[${index}].trait.traitValue`, {
                                  required: true,
                                }),
                              }}
                            />
                          </GridItem>
                        </>
                      )}

                      <GridItem xs={12} sm={12} md={1}>
                        <Button
                          justIcon={true}
                          color="danger"
                          size="sm"
                          onClick={() => remove(index)}
                        >
                          <Remove />
                        </Button>
                      </GridItem>
                    </GridContainer>
                  ))}
                </GridItem>

                <GridItem xs={12} sm={12} md={4}>
                  <GridContainer justify="flex-end">
                    <GridItem xs={12} sm={12} md={12}>
                      <p>Image: </p>
                      <Controller
                        control={control}
                        name="image"
                        render={({ field: { value, onChange } }) => (
                          <ImageUpload value={value} onChange={onChange} />
                        )}
                      />
                    </GridItem>
                  </GridContainer>
                </GridItem>

                <GridItem xs={12} sm={12} md={12}>
                  <h4> Claim fee </h4>

                  <GridContainer>
                    <GridItem xs={12} sm={12} md={2}>
                      <FormLabel className={classes.labelHorizontal}>Claim fee</FormLabel>
                    </GridItem>

                    <GridItem xs={12} sm={12} md={4}>
                      <CustomInput
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "number",
                          step: 0.001,
                          ...staking("softConfig.claimFee", {
                            required: true,
                            min: 0,
                            valueAsNumber: true,
                          }),
                        }}
                      />
                    </GridItem>
                  </GridContainer>

                  <GridContainer alignItems="center">
                    <GridItem xs={12} sm={12} md={2}>
                      <FormLabel className={classes.labelHorizontal}>Special claim fee</FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={3}>
                      <Button
                        justIcon={true}
                        color="success"
                        size="sm"
                        onClick={() => {
                          appendFee({
                            collectionAddress: "",
                            collectionName: "",
                            collectionLink: "",
                            fee: {
                              claim: defaultClaimFee,
                            },
                          });
                        }}
                      >
                        <Add />
                      </Button>
                    </GridItem>
                  </GridContainer>

                  {specialFeeFields.map((field, index) => (
                    <GridContainer key={field.id} alignItems="center">
                      <GridItem xs={12} sm={12} md={2}>
                        <FormLabel className={classes.labelHorizontal}>Fee {index + 1}</FormLabel>
                      </GridItem>

                      <GridItem xs={12} sm={12} md={2}>
                        <CustomInput
                          labelText="Collection address"
                          formControlProps={{
                            fullWidth: true,
                          }}
                          inputProps={{
                            required: true,
                            placeholder: "0x123",
                            ...staking(`softConfig.specialFees[${index}].collectionAddress`, {}),
                          }}
                        />
                      </GridItem>

                      <GridItem xs={12} sm={12} md={2}>
                        <CustomInput
                          labelText="Collection name"
                          formControlProps={{
                            fullWidth: true,
                          }}
                          inputProps={{
                            required: true,
                            placeholder: "Corgi",
                            ...staking(`softConfig.specialFees[${index}].collectionName`),
                          }}
                        />
                      </GridItem>

                      <GridItem xs={12} sm={12} md={2}>
                        <CustomInput
                          labelText="Collection link"
                          formControlProps={{
                            fullWidth: true,
                          }}
                          inputProps={{
                            placeholder: "corgistudio.io",
                            ...staking(`softConfig.specialFees[${index}].collectionLink`),
                          }}
                        />
                      </GridItem>

                      <GridItem xs={12} sm={12} md={1}>
                        <Button
                          justIcon={true}
                          color="danger"
                          size="sm"
                          onClick={() => removeFee(index)}
                        >
                          <Remove />
                        </Button>
                      </GridItem>

                      <GridItem xs={12} sm={12} md={4}>
                        <FormLabel className={classes.labelHorizontal}>Quantity 1:</FormLabel>
                      </GridItem>

                      <GridItem xs={12} sm={12} md={2}>
                        <CustomInput
                          labelText="Min quantity"
                          formControlProps={{
                            fullWidth: true,
                          }}
                          inputProps={{
                            required: true,
                            placeholder: 1,
                            type: "number",
                            step: 1,
                            min: 1,
                            ...staking(`softConfig.specialFees[${index}].fees[0].quantity`, {
                              valueAsNumber: true,
                            }),
                          }}
                        />
                      </GridItem>

                      <GridItem xs={12} sm={12} md={2}>
                        <CustomInput
                          labelText="Claim fee"
                          formControlProps={{
                            fullWidth: true,
                          }}
                          inputProps={{
                            required: true,
                            placeholder: 0.25,
                            type: "number",
                            step: 0.00001,
                            min: 0,
                            ...staking(`softConfig.specialFees[${index}].fees[0].claimFee`, {
                              valueAsNumber: true,
                            }),
                          }}
                        />
                      </GridItem>

                      <GridItem md={18} />

                      <GridItem xs={12} sm={12} md={4}>
                        <FormLabel className={classes.labelHorizontal}>Quantity 2:</FormLabel>
                      </GridItem>

                      <GridItem xs={12} sm={12} md={2}>
                        <CustomInput
                          labelText="Min quantity"
                          formControlProps={{
                            fullWidth: true,
                          }}
                          inputProps={{
                            placeholder: 10,
                            type: "number",
                            step: 1,
                            min: 1,
                            ...staking(`softConfig.specialFees[${index}].fees[1].quantity`, {
                              valueAsNumber: true,
                            }),
                          }}
                        />
                      </GridItem>

                      <GridItem xs={12} sm={12} md={2}>
                        <CustomInput
                          labelText="Claim fee"
                          formControlProps={{
                            fullWidth: true,
                          }}
                          inputProps={{
                            placeholder: 0.25,
                            type: "number",
                            step: 0.00001,
                            min: 0,
                            ...staking(`softConfig.specialFees[${index}].fees[1].claimFee`, {
                              valueAsNumber: true,
                            }),
                          }}
                        />
                      </GridItem>
                    </GridContainer>
                  ))}
                </GridItem>

                <GridItem xs={12} sm={12} md={4} style={{ marginTop: 40 }}>
                  <Button onClick={() => history.goBack()}>Cancel</Button>
                  <Button color="rose" type="submit">
                    {loading ? "Loading..." : "Submit"}
                  </Button>
                </GridItem>
              </GridContainer>
            </form>
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}
